import { ChangeDetectionStrategy, Component, computed, effect, HostBinding, input } from '@angular/core';

import { IconModule, IconSize } from '@hglobal/fin-ui';

@Component({
  selector: 'kr-status-icon',
  imports: [IconModule],
  templateUrl: './status-icon.component.html',
  styleUrl: './status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIconComponent {
  iconName = input<string>();
  status = input<'info' | 'danger' | 'success' | 'default'>('default');
  size = input<'small' | 'large'>('small');
  numberSize = computed<IconSize>(() => (this.size() === 'small' ? '32' : '72'));

  hostClassesEffect = effect(() => (this.hostClasses = `status-icon status-icon ${this.status()}`));

  @HostBinding('class') hostClasses = '';
}
